import $ from "jquery";
import GLightbox from "glightbox";

$(window).on('load', function () {
	const lightbox = GLightbox({
		selector: '.glightbox',
		touchNavigation: true,
		loop: true,
		autoplayVideos: true,
		videosWidth: '100vw',
		plyr: {
			config: {
				muted: false // helps autoplay work in all browsers
			}
		}
	});
});